import {createApi, fetchBaseQuery} from '@reduxjs/toolkit/query/react'
import {config} from 'services/config'
import {IAccess, ICredentials, IUser} from "models/auth";
import {prepareHeaders} from "./index";


export const authAPI = createApi({
    reducerPath: 'authAPI',
    baseQuery: fetchBaseQuery({
        baseUrl: config.BASE_URL,
        prepareHeaders: prepareHeaders,
    }),
    tagTypes: ['User'],
    endpoints: (builder) => ({
        login: builder.mutation<IAccess, ICredentials>({
            query: (args: ICredentials) => {
                return {
                    url: '/token/',
                    method: 'POST',
                    body: {
                        username: args.username,
                        password: args.password,
                    },
                    headers: {
                        'Content-Type': 'application/json',
                    },
                };
            },
            invalidatesTags: [{type: 'User', id: 'current'}],
        }),
        getCurrentUser: builder.query<IUser, string>({
            query: (token: string) => ({
                url: 'users/me/',
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }),
            providesTags: [{type: 'User', id: 'current'}],
        }),
    })
})
export const {
    useLoginMutation,
    useGetCurrentUserQuery
} = authAPI
